import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to fetch ads data based on area_id
export const fetchAds = createAsyncThunk(
  'ads/fetchAds',
  async (areaId) => {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/getAds?areaId=${areaId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch ads');
    }
    const data = await response.json();
    return data.data; // Assuming the response contains the ads array
  }
);

// Initial state for ads
const initialState = {
  ads: [],
  status: 'idle', // idle, loading, succeeded, failed
  error: null,
};

const adSlice = createSlice({
  name: 'ads',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAds.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAds.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.ads = action.payload; // Set fetched ads
      })
      .addCase(fetchAds.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default adSlice.reducer;
